import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedWindAlarmMetric } from "../redux/windAlarmWindow";
import { useTheme } from "../styles/themes/themeContext";
import { WIND_ALARM_METRICS } from "./utility/windAlarmWindows";

const WindAlarmMetricSelector = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isVisible = useSelector((state) =>
    Object.values(state.shadingSystem.windAlarmSensors || {}).some(Boolean),
  );
  const selectedMetric = useSelector(
    (state) => state.windAlarmWindow.selectedMetric,
  );

  if (!isVisible) return null;

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={selectedMetric}
      onChange={(_event, nextMetric) => {
        if (nextMetric) dispatch(setSelectedWindAlarmMetric(nextMetric));
      }}
      sx={{
        background: "white",
        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
        borderRadius: "8px",
        "& .MuiToggleButton-root": {
          textTransform: "none",
          px: 1.5,
          py: 0.5,
          fontSize: 13,
          borderColor: "#ddd",
          color: "#333",
        },
        "& .Mui-selected": {
          backgroundColor: `${theme.primary} !important`,
          color: "white !important",
        },
        "& .Mui-selected:hover": {
          backgroundColor: `${theme.primary} !important`,
          filter: "brightness(0.92)",
        },
      }}
    >
      {WIND_ALARM_METRICS.map((metric) => (
        <ToggleButton key={metric.key} value={metric.key}>
          {metric.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default WindAlarmMetricSelector;
